import { tKey } from 'ember-intl';

export const PAYMENT_METHOD_CREDIT_CARD = 'credit_card';

export const PAYMENT_METHOD_DIRECT_DEBIT = 'direct_debit';

export const PAYMENT_METHOD_CHECK = 'check';

export const PAYMENT_METHOD_BANK_TRANSFER = 'bank_transfer';

export type PaymentMethod =
  | typeof PAYMENT_METHOD_CREDIT_CARD
  | typeof PAYMENT_METHOD_DIRECT_DEBIT
  | typeof PAYMENT_METHOD_CHECK
  | typeof PAYMENT_METHOD_BANK_TRANSFER;

export const PAYMENT_METHOD_TRANSLATIONS: Record<PaymentMethod, string> = {
  [PAYMENT_METHOD_CREDIT_CARD]: tKey('payments.payment_method.credit_card'),
  [PAYMENT_METHOD_DIRECT_DEBIT]: tKey('payments.payment_method.direct_debit'),
  [PAYMENT_METHOD_CHECK]: tKey('payments.method_selection.check'),
  [PAYMENT_METHOD_BANK_TRANSFER]: tKey(
    'payments.method_selection.bank_transfer',
  ),
};
